import { LANGUAGES, LANG_PARAM } from "./languages.js"

const LANG_PARAM_ENABLED = process.env.GATSBY_STORE !== "PH"

export const isLangParamEnabled = () => LANG_PARAM_ENABLED

const LEGACY_LOCALE_TO_REGION = { zh_Hans_HK: "hk", en_AU: "us", en_CA: "ca", en_JP: "us", en_UK: "uk" }

const normalizeLangValue = (value) =>
	typeof value === "string" ? value.trim().replace(/-/g, "_").toLowerCase() : ""

const firstMatch = (predicate) => LANGUAGES.find(predicate)?.code ?? null

export const resolveRegion = (stored) => {
	if (!stored) return null
	return firstMatch((l) => l.code === stored) ?? LEGACY_LOCALE_TO_REGION[stored] ?? null
}

export const urlLangToRegion = (value) => {
	const key = normalizeLangValue(value)
	if (!key) return null
	return (
		firstMatch((l) => l.urlLang.toLowerCase() === key) ??
		firstMatch((l) => l.code === key) ??
		firstMatch((l) => l.locale.toLowerCase() === key) ??
		Object.entries(LEGACY_LOCALE_TO_REGION).find(([k]) => k.toLowerCase() === key)?.[1] ??
		null
	)
}

export const regionToUrlLang = (region) =>
	LANGUAGES.find((l) => l.code === region)?.urlLang ?? null

export const readLangParam = (search) => new URLSearchParams(search || "").get(LANG_PARAM)

export const withLangParam = (search, region) => {
	const params = new URLSearchParams(search || "")
	params.set(LANG_PARAM, regionToUrlLang(region))
	return `?${params.toString()}`
}

const splitPath = (to) => {
	let path = to
	let hash = ""
	let search = ""
	const hashIndex = path.indexOf("#")
	if (hashIndex !== -1) {
		hash = path.slice(hashIndex)
		path = path.slice(0, hashIndex)
	}
	const searchIndex = path.indexOf("?")
	if (searchIndex !== -1) {
		search = path.slice(searchIndex)
		path = path.slice(0, searchIndex)
	}
	return { pathname: path, search, hash }
}

const isLangEligiblePath = (to) =>
	typeof to === "string" && ((to.startsWith("/") && !to.startsWith("//")) || to.startsWith("?"))

export const withLangPath = (to, region) => {
	if (!isLangEligiblePath(to) || !regionToUrlLang(region)) return to
	const { pathname, search, hash } = splitPath(to)
	return `${pathname}${withLangParam(search, region)}${hash}`
}
